<template lang="html">
    <div class="stream-player" :class="{'is-black': isPlaying && !src && !isStopped}">
        <div class="stream-player-video" :class="{'is-hidden': src || isPlaying}"></div>
        <video ref="stream_janus" id="stream_janus" class="stream-janus-video" :class="{'is-visibility': isPlaying && !src && !isStopped}" autoplay playsinline muted></video>
        <button @click="play"
          v-if="!loading && !loadingProp && !isPlaying"
          class="stream-play"
          type="button"
          title="Play Video" aria-disabled="false">
          <span aria-hidden="true" class="vjs-icon-placeholder"></span>
        </button>
        <div class="preloader-wrapper" v-if="loading || loadingProp">
          <vpreloader width="2" size="64" />
        </div>
    </div>
</template>

<script>
import adapter from 'webrtc-adapter';
import axios from 'axios';

export default {
    name: 'stream-video-player',

    props: ['src', 'interview', 'isPlaying', 'isStopped', 'isStreamPlayingEnd', 'isTest', 'loadingProp'],

    data() {
        return {
            requestVideoSrc: false,
            secondRequestVideoSrc: false,
            loading: false
        }
    },

    watch: {
      isStreamPlayingEnd(val) {
        if (val) {
          this.requestVideoSrc = false;
          this.secondRequestVideoSrc = false;
          this.loading = false;
        }
      },

      isPlaying(val) {
        if (val && this.isTest) {
          this.$refs.stream_janus.muted = false;
        } else {
          this.$refs.stream_janus.muted = true;
        }
      },

      loadingProp(val) {
        if (!val) {
          this.requestVideoSrc = false;
          this.secondRequestVideoSrc = false;
        }
      }
    },

    methods: {
        fetch () {
          return this.interview.token && this.$store.dispatch('interview/videointerview/fetch', {
              interview: this.interview
          })
            .then(() => {
              if (this.src) {
                this.loading = false;
                this.requestVideoSrc = false,
                this.secondRequestVideoSrc = false,
                this.loading = false
                this.$emit('startPlayer');
                return;
              }
              if (this.secondRequestVideoSrc && !this.src) {
                this.startStream();
                this.secondRequestVideoSrc = false;
                this.requestVideoSrc = false;
              }
              this.loading = false;
            });
        },

        play() {
            if (this.isTest) {
                this.startStream();
                return;
            }
          this.$emit('startPlayer');
          if (!this.src && !this.requestVideoSrc) {
            this.loading = true;
            this.requestVideoSrc = true;
            this.fetch()
              .then(() => {
                if (!this.src) {
                  this.loading = true;
                  setTimeout(() => {
                    this.secondRequestVideoSrc = true;
                    this.fetch();
                  }, 7000);
                } else {
                  this.loading = false;
                  this.$emit('startPlayer');
                }
              });
          }
        },

        startStream() {
          this.$emit('startStream');
        }
    },

    mounted() {

    },

    beforeDestroy() {
      this.secondRequestVideoSrc = false;
      this.requestVideoSrc = false;
      this.loading = false;
    },
}
</script>

<style lang="scss" scoped>
  .stream-player {
    position: relative;
    width: 444px;
    max-width: calc(100vw - 40px);
    height: 296px;
    border-radius: 2px;
    overflow: hidden;

    &.is-black {
      background: #000;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    @media only screen and (max-width: 1024px) {
      width: 100%;
    }

    @media only screen and (max-width: 480px) {
      height: 192px;
    }
  }
  .stream-player-video {
    background: #000;
    width: 100%;
    height: 100%;

    &.is-hidden {
      opacity: 0;
      visibility: hidden;
      position: absolute;
      left: -9999px;
    }
  }
  .stream-play {
    background-color: rgba(0, 0, 0, 0.45);
    font-size: 35px;
    height: 65px !important;
    width: 100px;
    line-height: 70px !important;
    margin-top: -35px!important;
    display: block;
    margin-left: -52px;
    position: absolute;
    top: 50%;
    left: 50%;
    padding: 0;
    cursor: pointer;
    opacity: 1;
    border: 2px solid #fff;
    border-radius: 10px;
    transition: all 0.4s;
    color: #fff;
  }
  .preloader-wrapper {
    position: absolute;
    width: 78px;
    height: 78px;
    left: calc(50% - 39px);
    top: calc(50% - 39px);
  }
  .vjs-icon-placeholder {
    &:before {
      content: "\F101" !important;
      border: none !important;
      background: none !important;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      font-family: VideoJS;
      text-align: center;
      display: inline-block;
    }
  }

  .stream-janus-video {
    max-width: 100%;
    opacity: 0;
    visibility: hidden;
    position: absolute;
    left: -9999px;

    &.is-visibility {
      opacity: 1;
      visibility: visible;
      position: static;
      width: 100%;
      height: 192px;
    }
  }
</style>
